import {Component, OnDestroy, OnInit} from '@angular/core';
import {KeycloakService} from 'keycloak-angular';
import {LoggingService, MenuService} from 'mclane-apptemplate-lib';
import {Subscription} from 'rxjs';
import {environment} from '~/environments/environment';
import {AuthServicesService, JwtService, OauthService} from 'mclane-webauth-lib';
import { bellIcon } from '@progress/kendo-svg-icons';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
    public bellIcon = bellIcon;

    env = environment;

    menutype: any[] = [];
    private sub: Subscription;

    ngOnDestroy(): void {
        this.sub.unsubscribe();
    }

    ngOnInit() {
        this.buildMenu();
        this.subscribeToMenu();
    }

    constructor(public keycloakService: KeycloakService,
                public menuservice: MenuService,
                public jwtService: JwtService,
                public oauthService: OauthService,
                public console: LoggingService,
                public  authService: AuthServicesService) {
    }

    buildMenu() {
        let userText;
        if (this.jwtService.isLoggedIn()) {

            const userprofile =  environment.keycloak.url + '/realms/' + environment.keycloak.realm + '/account/';
            let username: string;
            const givenName = this.jwtService.getJwtAttribute('given_name');
            if (givenName === undefined || givenName === '') {
                username = this.jwtService.getJwtAttribute('preferred_username');
            } else {
                username = givenName;
            }

            userText = `Welcome ${username}`;
            this.menutype = [
                {
                    text: '',
                    separator: false,
                    icon: bellIcon,
                    disabled: false,
                    textColor: 'green',
                    url: '',
                    subItems: null,
                    class: 'iconOnly'
                },
                {text: 'Home', separator: false, icon: '', disabled: false, textColor: 'white', url: 'home', subItems: null}
            ];
            this.menuservice.setItems(this.menutype, username, true);
        } else {
            this.menutype = [
                {
                    text: 'Login',
                    separator: false,
                    icon: '',
                    disabled: false,
                    textColor: 'green',
                    url: '',
                    subItems: null
                }
            ];
        }
        this.menuservice.setItems(this.menutype, null, false);
    }

    subscribeToMenu() {
        this.sub = this.menuservice.eventRan.subscribe( (result: any) => {
            this.console.log(result);
            if (result.text === 'Logout') {
               this.oauthService.logoutOfApplication('');
             //  this.oauthService.serverLogout().then();

            }
            if (result.text === 'Login') {
                const hint = this.oauthService.tryGetIdpCookie();
                this.oauthService.loginExtended({idpHint: hint}).then((item) => {
                    this.console.log(item);
                });
            }
        });
    }
}
